import { render } from "./EventHostView.vue?vue&type=template&id=58a51e78"
import script from "./EventHostView.vue?vue&type=script&lang=js"
export * from "./EventHostView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\GINGO\\Documents\\GitHub\\fomofinal\\fomoapp\\frontend3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__